<template>
  <div>
    <template v-if="[2, 3, 4, 5, 6].includes(current)">
      <a-table
        v-for="(item, index) in document.invoiceTable"
        :key="index"
        :columns="columns"
        :data-source="item.sum_distribution"
        :pagination="{ hideOnSinglePage: true }"
        bordered
        :rowClassName="(record) => `permission-${record.accept.status}`"
        :scroll="{ y: 240 }"
        size="small"
        style="padding: 0 25px"
      >
        <template slot="mpk" slot-scope="text">{{ text }}</template>

        <template slot="type" slot-scope="text">{{ text }}</template>

        <template slot="firma" slot-scope="text">
          <a
            v-if="COMPANY_LIST[text]"
            :href="`https://${domain}/crm/company/details/${text}/`"
            target="_blank"
            >{{ COMPANY_LIST[text]["TITLE"] }}</a
          >
        </template>

        <template slot="budget" slot-scope="text, record, index">
          {{ text.nameBudget }} - {{ text.namePosition }}
          <span v-if="sumCheckTable[index]">
            <a-icon
              v-if="sumCheckTable[index] == '!'"
              style="color: #dc143c"
              type="exclamation-circle"
          /></span>
          <span v-else>{{
            checkSumBudget(text.idBudget, text.idPosition, record.sum, index)
          }}</span>
        </template>

        <template slot="sum" slot-scope="text">{{ text }}</template>

        <template slot="operation" slot-scope="text, record">
          <span
            v-if="record.accept.permission && current == 2"
            @click="
              () => {
                record.accept.status = !record.accept.status;
                if (record.accept.status) record.accept.user = profile.ID;
                checkChangedVal = true;
              }
            "
            style="margin-right: 15px"
          >
            <a-button type="link" v-if="record.accept.status">
              <a-icon
                type="check-circle"
                theme="twoTone"
                two-tone-color="#52c41a"
              />
              {{ $t("Tak") }}
            </a-button>
            <a-button type="link" v-else>
              <a-icon
                type="close-circle"
                theme="twoTone"
                two-tone-color="#eb2f96"
              />
              {{ $t("Nie") }}
            </a-button>
          </span>
          <span v-else style="margin-right: 15px">
            <span v-if="record.accept.status">
              <a-icon
                type="check-circle"
                theme="twoTone"
                two-tone-color="#52c41a"
              />&nbsp;{{ $t("Tak") }}
            </span>
            <span v-else>
              <a-icon
                type="close-circle"
                theme="twoTone"
                two-tone-color="#eb2f96"
              />&nbsp;{{ $t("Nie") }}
            </span>
          </span>
          <a-tooltip placement="bottomRight">
            <template slot="title" v-if="current == 2">
              <a-tag
                color="#2C7FE4"
                v-for="item in record.accept.accept_users"
                :key="item"
                >{{ getUser(item) }}</a-tag
              >
            </template>
            <template slot="title" v-else>
              <a-tag color="#2C7FE4">{{ getUser(record.accept.user) }}</a-tag>
            </template>
            <a-icon type="user" />
          </a-tooltip>
        </template>

        <template slot="title">
          <a-row
            type="flex"
            justify="space-around"
            align="middle"
            style="font-weight: 700"
          >
            <span
              >{{ $t("Position") + " " + ++index }} : {{ item.namefield }} ({{
                item.koszty
              }})</span
            >
          </a-row>
          <div></div>
        </template>
      </a-table>
    </template>
    <a-form :form="form" id="my_form_styl" layout="vertical" v-else>
      <h2 style="color: firebrick; font-weight: 700">
        {{ $t("Podział kosztów") }}
      </h2>
      <div style="font-weight: 700" v-show="document.invoiceAutoNumber">
        {{ document.invoiceAutoNumber }} | {{ document.invoiceTitle }}
      </div>
      <a-row type="flex" justify="space-between" style="margin: 0">
        <template v-if="profile.ADMIN">
          <a-col
            :span="14"
            style="
              border: 1px solid rgb(211, 211, 211);
              border-radius: 5px;
              padding: 0;
              border-bottom: none;
              height: max-content;
            "
          >
            <a-form-item :label="$t('File name')">
              <a-tooltip>
                <template slot="title">
                  <span>{{ document.NAME }}</span>
                </template>
                <span>{{ document.NAME }}</span>
              </a-tooltip>
            </a-form-item>

            <a-form-item :label="$t('Status')">
              <a-tag style="font-weight: bold" :color="statusTag.color">{{
                $t(document.status)
              }}</a-tag>
            </a-form-item>

            <a-form-item :label="$t('Main Company')">
              <!--<a-select
                showSearch
                optionFilterProp="children"
                @change="handlerChangeMainCompany"
                v-decorator="[
                  'my_company',
                  {
                    rules: [{ required: false }],
                    initialValue: document.my_company,
                  },
                ]"
              >
                <a-select-option
                  v-for="(comp, id) in MY_COMPANY_LIST"
                  :key="id"
                >{{ comp["TITLE"] }}</a-select-option>
              </a-select>-->
              <a-input
                @change="changePromptStatus"
                @click="handleChangeMyCompany()"
                v-model="myCompanyTitle"
              />
            </a-form-item>

            <a-form-item :label="$t('Contractor')">
              <!-- <a-select
                showSearch
                optionFilterProp="children"
                @change="handlerChangeContractor"
                v-decorator="[
                  'kontragent',
                  {
                    rules: [{ required: false }],
                    initialValue: document.kontragent,
                  },
                ]"
              >
                <a-select-option
                  v-for="(comp, id) in COMPANY_LIST"
                  :key="id"
                >{{
                  comp["TITLE"]
                }}</a-select-option>
              </a-select>-->
              <a-input
                @change="changePromptStatus"
                @click="handleChangeContractor()"
                v-model="contactorTitle"
              />
            </a-form-item>

            <a-form-item :label="$t('Bank account')">
              <div style="display: flex">
                <a-auto-complete
                  :data-source="bankAccountList"
                  :filter-option="filterOption"
                  v-decorator="[
                    'bankAccount',
                    {
                      rules: [{ required: false }],
                      initialValue: document.bankAccount,
                    },
                  ]"
                />
                <a-button @click="addBankAccount" type="primary" icon="plus" />
              </div>
            </a-form-item>
            <a-form-item :label="$t('Invoice number')">
              <a-input
                v-decorator="[
                  'num_invoice',
                  {
                    rules: [{ required: false }],
                    initialValue: document.num_doc,
                  },
                ]"
              />
            </a-form-item>
            <a-form-item :label="$t('Type')">{{
              invoiceTypeSelect[document.invoiceType]
            }}</a-form-item>
            <a-form-item
              v-if="document.invoiceCorrection"
              :label="$t('Correction')"
            >
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                "
              >
                <div>{{ document.invoiceCorrection }}</div>
                <a-button @click="showPreview" type="primary" icon="eye" />
              </div>
            </a-form-item>

            <a-form-item :label="$t('Payment')">
              <a-col :span="11">
                <a-select
                  v-decorator="[
                    'paymentType',
                    {
                      rules: [{ required: false }],
                      initialValue: document.payment
                        ? document.payment.type
                        : 'Przelew',
                    },
                  ]"
                >
                  <a-select-option key="Gotówka">{{
                    $t("Gotówka")
                  }}</a-select-option>
                  <a-select-option key="Przelew">{{
                    $t("Przelew")
                  }}</a-select-option>
                  <a-select-option key="Karta">{{
                    $t("Karta")
                  }}</a-select-option>
                  <a-select-option key="Pobranie">{{
                    $t("Pobranie")
                  }}</a-select-option>
                  <a-select-option key="Kompensata">{{
                    $t("Kompensata")
                  }}</a-select-option>
                  <a-select-option key="Barter">{{
                    $t("Barter")
                  }}</a-select-option>
                  <a-select-option key="Płatność przez Pracownika">{{
                    $t("Płatność przez Pracownika")
                  }}</a-select-option>
                </a-select>
              </a-col>
            </a-form-item>

            <a-form-item :label="$t('Currency')">
              {{ document.currency.code }}
              <a-divider type="vertical" style="background: #d3d3d3" />
              {{ document.currency.val }}
            </a-form-item>

            <a-form-item :label="$t('Keywords')">
              <a-select
                mode="multiple"
                v-decorator="[
                  'key_words',
                  {
                    rules: [{ required: false }],
                    initialValue: document.key_words || [],
                  },
                ]"
              >
                <a-select-option v-for="i in key_words" :key="i">{{
                  i
                }}</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :label="$t('Tag')">
              <a-select
                :dropdownMatchSelectWidth="false"
                mode="tags"
                v-decorator="[
                  'Teczka',
                  {
                    rules: [{ required: false }],
                    initialValue: document.Teczka,
                  },
                ]"
              >
                <a-select-option v-for="i in info.teczkalist" :key="i">{{
                  i
                }}</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :label="$t('Owner')" class="last-block-item">
              <span>{{ getCompanyAssign(document.my_company) }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="9" style="padding: 0">
            <div
              style="
                border: 1px solid rgb(211, 211, 211);
                border-radius: 5px;
                border-bottom: none;
              "
            >
              <a-form-item :label="$t('Date of receiving')">
                <a-date-picker
                  style="width: 100%"
                  v-decorator="[
                    'date_send',
                    {
                      rules: [{ required: false }],
                      initialValue: document.date_send
                        ? moment(document.date_send, 'YYYY-MM-DD')
                        : '',
                    },
                  ]"
                />
              </a-form-item>
              <a-form-item :label="$t('Date of issue')">
                <a-date-picker
                  :format="YYYY - MM - DD"
                  style="width: 100%"
                  v-decorator="[
                    'date_recept',
                    {
                      rules: [{ required: false }],
                      initialValue: document.date_recept
                        ? moment(document.date_recept, 'YYYY-MM-DD')
                        : '',
                    },
                  ]"
                />
              </a-form-item>
              <a-form-item :label="$t('Sale date')">{{
                document.saleDate
              }}</a-form-item>
              <a-form-item :label="$t('Date of payment')">
                <a-date-picker
                  style="width: 100%"
                  :format="YYYY - MM - DD"
                  v-decorator="[
                    'paymentDate',
                    {
                      rules: [{ required: false }],
                      initialValue: document.paymentDate
                        ? moment(document.paymentDate, 'YYYY-MM-DD')
                        : '',
                    },
                  ]"
                />
              </a-form-item>
              <a-form-item :label="$t('Planned date')">
                <a-date-picker
                  style="width: 100%"
                  :format="YYYY - MM - DD"
                  v-decorator="[
                    'plannedDate',
                    {
                      rules: [{ required: false }],
                      initialValue: document.plannedDate
                        ? moment(document.plannedDate, 'YYYY-MM-DD')
                        : '',
                    },
                  ]"
                />
              </a-form-item>
              <a-form-item :label="$t('Reminder')" class="last-block-item">
                <a-date-picker
                  style="width: 100%"
                  :format="YYYY - MM - DD"
                  v-decorator="[
                    'reminderDate',
                    {
                      rules: [{ required: false }],
                      initialValue: document.reminderDate
                        ? moment(document.reminderDate, 'YYYY-MM-DD')
                        : '',
                    },
                  ]"
                />
              </a-form-item>
            </div>
            <div
              style="
                border: 1px solid rgb(211, 211, 211);
                border-radius: 5px;
                border-bottom: none;
                margin-top: 50px;
              "
            >
              <a-form-item
                :label="$t('Date of booking')"
                has-feedback
                :validate-status="validatePaymentDateReal"
              >
                <a-date-picker
                  :format="YYYY - MM - DD"
                  style="width: 100%"
                  @change="handlerChangePaymentDateReal"
                  v-decorator="[
                    'PaymentDateReal',
                    { rules: [{ required: false }], initialValue: moment() },
                  ]"
                />
              </a-form-item>
              <a-form-item class="last-block-item">
                <span slot="label">
                  {{ $t("Kwota") }}
                  <span>
                    <a-tag color="cyan">{{ kwotaVals.paidPercent }}%</a-tag>
                    <a-tag color="green">{{ kwotaVals.paidSum }}</a-tag>
                  </span>
                </span>
                <div style="display: flex">
                  <a-input-number
                    style="flex: 1"
                    :min="0"
                    :max="kwotaVals.leftToPay"
                    v-decorator="[
                      'kwotaVal',
                      { rules: [{ required: false }], initialValue: 0 },
                    ]"
                  />
                  <a-button-group style="margin-left: 10px">
                    <a-button
                      type="primary"
                      icon="plus"
                      @click="() => handlerKwotaAdd()"
                    />
                    <a-button
                      type="primary"
                      icon="history"
                      @click="kwotaHistoryVisible = !kwotaHistoryVisible"
                    />
                  </a-button-group>
                </div>
              </a-form-item>
            </div>
            <a-timeline
              style="padding: 15px 0 0 25px"
              v-show="kwotaHistoryVisible"
            >
              <a-timeline-item
                v-for="(item, index) in kwotaVals.history"
                :key="index"
              >
                <a-row type="flex" justify="space-around" align="middle">
                  <a-col :span="4">
                    {{ item.date }}
                  </a-col>
                  <a-col :span="4">
                    {{ item.payment }}
                  </a-col>
                  <a-col :span="4">
                    {{ getUser(item.user) }}
                  </a-col>
                  <a-col :span="4">
                    <a-button
                      type="link"
                      icon="delete"
                      style="color: #ff4d4f"
                      v-if="profile.ADMIN || profile.ID == item.user"
                      @click="() => handlerKwotaDelete(index)"
                    />
                  </a-col>
                </a-row>
              </a-timeline-item>
            </a-timeline>
            <a-row type="flex" justify="space-between" style="margin-top: 50px">
              <div style="font-weight: 700">{{ $t("Łączna kwota") }}</div>
              <div style="font-size: 18px">{{ common_sum }}</div>
            </a-row>
            <a-row type="flex" justify="space-between">
              <div style="font-weight: 700">{{ $t("VAT") }}</div>
              <div style="font-size: 18px">{{ common_vat }}</div>
            </a-row>
            <a-row type="flex" justify="space-between">
              <div style="font-weight: 700">
                {{ $t("Całkowita pozostałość") }}
              </div>
              <div style="font-size: 18px">{{ common_balance }}</div>
            </a-row>

            <a-progress
              style="padding-right: 15px"
              :percent="resultPercent"
              :status="
                resultPercent > 100
                  ? 'exception'
                  : resultPercent == 100
                  ? 'success'
                  : 'active'
              "
            />
          </a-col>
        </template>
        <template v-else>
          <a-col
            :span="14"
            style="
              border: 1px solid rgb(211, 211, 211);
              border-radius: 5px;
              padding: 0;
              border-bottom: none;
              height: max-content;
            "
          >
            <a-form-item :label="$t('File name')">
              <a-tooltip>
                <template slot="title">
                  <span>{{ document.NAME }}</span>
                </template>
                <span>{{ document.NAME }}</span>
              </a-tooltip>
            </a-form-item>

            <a-form-item :label="$t('Status')">
              <a-tag style="font-weight: bold" :color="statusTag.color">{{
                $t(document.status)
              }}</a-tag>
            </a-form-item>

            <a-form-item :label="$t('Main Company')">{{
              getCompany(document.my_company)
            }}</a-form-item>

            <a-form-item :label="$t('Contractor')">{{
              getCompany(document.kontragent)
            }}</a-form-item>

            <a-form-item :label="$t('Bank account')">{{
              document.bankAccount
            }}</a-form-item>
            <a-form-item :label="$t('Invoice number')">{{
              document.num_doc
            }}</a-form-item>
            <a-form-item :label="$t('Type')">{{
              document.invoiceType
            }}</a-form-item>
            <a-form-item
              v-if="document.invoiceCorrection"
              :label="$t('Correction')"
            >
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                "
              >
                <div>{{ document.invoiceCorrection }}</div>
                <a-button @click="showPreview" type="primary" icon="eye" />
              </div>
            </a-form-item>
            <a-form-item :label="$t('Payment')">
              <a-col :span="12">{{ document.payment.type }}</a-col>
              <a-col :span="12">{{ document.payment.date }}</a-col>
            </a-form-item>

            <a-form-item :label="$t('Currency')">
              {{ document.currency.code }}
              <a-divider type="vertical" style="background: #d3d3d3" />
              {{ document.currency.val }}
            </a-form-item>

            <a-form-item :label="$t('Keywords')">
              <span style="white-space: normal">
                <a-tag
                  v-for="(item, index) in document.key_words"
                  :key="index"
                  >{{ item }}</a-tag
                >
              </span>
            </a-form-item>

            <a-form-item :label="$t('Tag')">
              <a-tag v-for="(item, index) in document.Teczka" :key="index">{{
                item
              }}</a-tag>
            </a-form-item>

            <a-form-item :label="$t('Owner')" class="last-block-item">
              <span>{{ getCompanyAssign(document.my_company) }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="9" style="padding: 0">
            <div
              style="
                border: 1px solid rgb(211, 211, 211);
                border-radius: 5px;
                border-bottom: none;
              "
            >
              <a-form-item :label="$t('Date of receiving')">{{
                document.date_send
              }}</a-form-item>
              <a-form-item :label="$t('Date of issue')">{{
                document.date_recept
              }}</a-form-item>
              <a-form-item :label="$t('Sale date')">{{
                document.saleDate
              }}</a-form-item>
              <a-form-item :label="$t('Date of payment')">{{
                document.paymentDate
              }}</a-form-item>
              <a-form-item :label="$t('Planned date')">{{
                document.plannedDate
              }}</a-form-item>
              <a-form-item :label="$t('Reminder')" class="last-block-item">{{
                document.reminderDate
              }}</a-form-item>
            </div>
            <div
              style="
                margin-top: 50px;
                border: 1px solid rgb(211, 211, 211);
                border-radius: 5px;
                border-bottom: none;
              "
            >
              <a-form-item
                :label="$t('Date of booking')"
                has-feedback
                :validate-status="validatePaymentDateReal"
              >
                <a-date-picker
                  :format="YYYY - MM - DD"
                  style="width: 100%"
                  @change="handlerChangePaymentDateReal"
                  :disabled="disableFromResponsible"
                  v-decorator="[
                    'PaymentDateReal',
                    {
                      rules: [{ required: false }],
                      initialValue: document.PaymentDateReal
                        ? moment(document.PaymentDateReal, 'YYYY-MM-DD')
                        : '',
                    },
                  ]"
                />
              </a-form-item>
              <a-form-item class="last-block-item">
                <span slot="label">
                  {{ $t("Kwota") }}
                  <span>
                    <a-tag color="cyan">{{ kwotaVals.paidPercent }}%</a-tag>
                    <a-tag color="green">{{ kwotaVals.paidSum }}</a-tag>
                  </span>
                </span>
                <div style="display: flex">
                  <a-input-number
                    style="flex: 1"
                    :min="0"
                    :max="kwotaVals.leftToPay"
                    :disabled="disableFromResponsible"
                    v-decorator="[
                      'kwotaVal',
                      { rules: [{ required: false }], initialValue: 0 },
                    ]"
                  />
                  <a-button-group style="margin-left: 10px">
                    <a-button
                      type="primary"
                      icon="plus"
                      :disabled="disableFromResponsible"
                      @click="() => handlerKwotaAdd()"
                    />
                    <a-button
                      type="primary"
                      icon="history"
                      @click="kwotaHistoryVisible = !kwotaHistoryVisible"
                    />
                  </a-button-group>
                </div>
              </a-form-item>
            </div>
            <a-timeline
              style="padding: 15px 0 0 25px"
              v-show="kwotaHistoryVisible"
            >
              <a-timeline-item
                v-for="(item, index) in kwotaVals.history"
                :key="index"
              >
                <a-row type="flex" justify="space-around" align="middle">
                  <a-col :span="4">
                    {{ item.date }}
                  </a-col>
                  <a-col :span="4">
                    {{ item.payment }}
                  </a-col>
                  <a-col :span="4">
                    {{ getUser(item.user) }}
                  </a-col>
                  <a-col :span="4">
                    <a-button
                      type="link"
                      icon="delete"
                      style="color: #ff4d4f"
                      v-if="profile.ADMIN || profile.ID == item.user"
                      @click="() => handlerKwotaDelete(index)"
                    />
                  </a-col>
                </a-row>
              </a-timeline-item>
            </a-timeline>
            <a-row type="flex" justify="space-between" style="margin-top: 50px">
              <div style="font-weight: 700">Łączna kwota:</div>
              <div style="font-size: 18px">{{ common_sum }}</div>
            </a-row>
            <a-row type="flex" justify="space-between">
              <div style="font-weight: 700">VAT:</div>
              <div style="font-size: 18px">{{ common_vat }}</div>
            </a-row>
            <a-row type="flex" justify="space-between">
              <div style="font-weight: 700">Całkowita pozostałość:</div>
              <div style="font-size: 18px">{{ common_balance }}</div>
            </a-row>

            <a-progress
              style="padding-right: 15px"
              :percent="resultPercent"
              :status="
                resultPercent > 100
                  ? 'exception'
                  : resultPercent == 100
                  ? 'success'
                  : 'active'
              "
            />
          </a-col>
        </template>
      </a-row>
      <br />
      <a-table
        v-for="tableItem in document.invoiceTable"
        :key="tableItem.key"
        :columns="columns"
        :data-source="tableItem.sum_distribution"
        :pagination="{ hideOnSinglePage: true }"
        bordered
        size="small"
      >
        <template slot="mpk" slot-scope="mpk, record">
          <template v-if="disableFromResponsible">
            {{ record.mpk }}
          </template>
          <a-select
            v-else
            style="width: 100%"
            placeholder="Select mpk"
            v-model="record.mpk"
            allowClear
            show-search
            option-filter-prop="children"
            @change="() => checkSaveBtnDisabled()"
            :filter-option="filterOption"
          >
            <a-select-option v-for="(item, key) in mpk_types_cord" :key="key">{{
              key
            }}</a-select-option>
          </a-select>
        </template>

        <template slot="type" slot-scope="text, record">
          <template v-if="disableFromResponsible">
            {{ record.type }}
          </template>
          <a-select
            v-else
            style="width: 100%"
            placeholder="Select type"
            v-model="record.type"
            allowClear
            show-search
            @change="() => checkSaveBtnDisabled()"
            option-filter-prop="children"
            :filter-option="filterOption"
          >
            <a-select-option
              v-for="item in mpk_types_cord[record.mpk]"
              :key="item"
              >{{ item }}</a-select-option
            >
          </a-select>
        </template>

        <template slot="deal" slot-scope="deal, record, index">
          <template v-if="disableFromResponsible">
            {{ record.deal }}
          </template>
          <div
            v-else
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <a-input
              :value="
                record.deal
                  ? testObj[record.deal]
                    ? testObj[record.deal]
                    : findDeal(record.deal)
                  : ''
              "
              @change="
                () => {
                  findDeal(record.deal);
                }
              "
              @click="handleChangeOnlyDeal(tableItem.key, index)"
            />

            <!-- <a-input
              :value="findDeal(record.deal)"
              @change="handleChangeDeal(tableItem.key, index)"
              @click="handleChangeDeal(tableItem.key, index)"
            ></a-input>-->
            <!--            <a-select-->
            <!--              style="width: 100%"-->
            <!--              placeholder="Select deal"-->
            <!--              allowClear-->
            <!--              @change="(e) => handleChangeDeal(e, tableItem.key, index)"-->
            <!--              v-model="record.deal"-->
            <!--              show-search-->
            <!--              option-filter-prop="children"-->
            <!--              :filter-option="filterOption"-->
            <!--            >-->
            <!--              <template v-if="record.firma">-->
            <!--                <a-select-option-->
            <!--                  v-for="i of document.alldeal.filter(-->
            <!--                    (x) => x.COMPANY_ID == record.firma-->
            <!--                  )"-->
            <!--                  :key="i.ID"-->
            <!--                  :value="i.ID"-->
            <!--                >{{ i.TITLE + ' (' + i.ID + ')' }}</a-select-option>-->
            <!--              </template>-->
            <!--              <template v-else>-->
            <!--                <a-select-option-->
            <!--                  v-for="i of document.alldeal"-->
            <!--                  :key="i.ID"-->
            <!--                >{{i.TITLE + ' (' + i.ID + ')'}}</a-select-option>-->
            <!--              </template>-->
            <!--            </a-select>-->
            <a
              v-if="record.deal"
              :href="`https://${domain}/crm/deal/details/${record.deal}/`"
              target="_blank"
              style="padding-left: 10px"
            >
              <a-icon type="eye"></a-icon>
            </a>
          </div>
        </template>

        <template slot="firma" slot-scope="firma, record, index">
          <template v-if="disableFromResponsible">
            {{ findCompany(record.firma) }}
          </template>
          <div
            v-else
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <!--<a-select
              style="width: 210px"
              allowClear
              @change="(e) => handleChangeFirma(e, tableItem.key, index)"
              v-model="record.firma"
              show-search
              option-filter-prop="children"
              :filter-option="filterOption"
            >
              <a-select-option
                v-for="(company, id) of COMPANY_LIST"
                :key="id"
                >{{ company.TITLE }}</a-select-option
              >
            </a-select>-->
            <!--<a-input
              :value="findCompany(record.firma)"
              @click="handleChangeFirma(tableItem.key, index)"
            />-->
            <a-input
              :value="
                record.firma
                  ? companyObj[record.firma]
                    ? companyObj[record.firma]
                    : findCompany(record.firma)
                  : ''
              "
              @change="
                () => {
                  findCompany(record.firma);
                }
              "
              @click="handleChangeFirma(tableItem.key, index)"
            />
            <a
              v-if="record.firma"
              :href="`https://${domain}/crm/company/details/${record.firma}/`"
              target="_blank"
              style="padding-left: 10px"
            >
              <a-icon type="eye"></a-icon>
            </a>
          </div>
        </template>

        <template slot="sum" slot-scope="sum, record, index">
          <template v-if="disableFromResponsible">
            {{ record.sum }}
          </template>
          <template v-else>
            <div>
              <a-input
                placeholder="sum..."
                style="min-width: 100px"
                :value="record.sum"
                @change="
                  (e) => onInputSum(tableItem.key, index, e.target.value, true)
                "
              />
            </div>
          </template>
        </template>
        <!--<template slot="budget" slot-scope="text, record, index">
          <template v-if="disableFromResponsible">
            {{ getNameBudget(text.idBudget) }}
          </template>
          <template v-else>
            {{ getNameBudget(text.idBudget) }}
            <a-select
              style="margin-top: 5px"
              v-model="text.idPosition"
              :disabled="text.idBudget == null"
              @change="
                (el) => {
                  handleChangeBudgetPosition(el, tableItem.key, index, text);
                }
              "
            >
              <a-select-option
                v-for="position of positionsSelect[index]"
                :key="position.key"
                :value="position.id"
                >{{ position.namePosition }}</a-select-option
              >
            </a-select>
            {{ calcBalanceBudget(tableItem.key, index) }}
          </template>
        </template>-->
        <template slot="operation" slot-scope="operation, record, index">
          <a-popconfirm
            v-if="
              tableItem.sum_distribution.length > 1 && !disableFromResponsible
            "
            title="Sure to delete?"
            @confirm="() => onDelete(tableItem.key, index)"
          >
            <a href="javascript:;">
              <a-icon type="delete" />
            </a>
          </a-popconfirm>
        </template>
        <template slot="title">
          <a-row
            type="flex"
            justify="space-around"
            align="middle"
            style="font-weight: 700"
          >
            <span
              >{{ $t("Position") + " " + (+tableItem.key + 1) }} :
              {{ tableItem.namefield }} ({{ tableItem.koszty }})</span
            >
            <span style="color: green"
              >{{ $t("Balance") }}:
              {{
                typeof tableItem.balance_sum == "number"
                  ? tableItem.balance_sum.toFixed(2)
                  : ""
              }}</span
            >
          </a-row>
          <div></div>
        </template>

        <template slot="footer">
          <div style="text-align: center">
            <a-button
              type="primary"
              :disabled="isSaveDisabled || disableFromResponsible"
              style="width: 20%"
              @click="() => handleAdd(tableItem.key)"
              >{{ $t("Add") }}</a-button
            >
          </div>
        </template>
      </a-table>
    </a-form>
  </div>
</template>

<script>
import {
  requestStep,
  getCurrency,
  getBudget,
  getPosition,
} from "@/requestFunc";
import moment from "moment";

export default {
  props: [
    "document",
    "profile",
    "COMPANY_LIST",
    "MY_COMPANY_LIST",
    "USER_LIST",
    "user_setup",
    "info",
    "key_words",
    "statusTag",
    "disableFromResponsible",
    "current",
    "defaultResponsible",
  ],
  data() {
    return {
      validatePaymentDateReal: "success",
      columns: [
        {
          title: this.$t("Centry kosztów"),
          dataIndex: "mpk",
          width: "14%",
          scopedSlots: { customRender: "mpk" },
        },
        {
          title: this.$t("Typy kosztów"),
          dataIndex: "type",
          width: "14%",
          scopedSlots: { customRender: "type" },
        },
        {
          title: this.$t("Projekty"),
          dataIndex: "deal",
          width: "14%",
          customRender: (text) => {
            let deal = this.document.alldeal.find((x) => x.ID == text);
            if (text && deal) {
              return (
                <a
                  href={`https://${this.domain}/crm/deal/details/${text}/`}
                  target="_blank"
                >
                  {deal["TITLE"]}
                </a>
              );
            }
            return "";
          },
        },
        {
          title: this.$t("Firma"),
          dataIndex: "firma",
          width: "14%",
          //scopedSlots: { customRender: "firma" },
          customRender: (text) => {
            let company = this.document.arrayCompany.find((x) => x.ID == text);
            if (text && company) {
              return (
                <a
                  href={`https://${this.domain}/crm/company/details/${text}/`}
                  target="_blank"
                >
                  {company["TITLE"]}
                </a>
              );
            }
            return "";
          },
        },
        /*{
          title: "Budget",
          dataIndex: "budget",
          width: "14%",
          scopedSlots: { customRender: "budget" },
        },*/
        {
          title: this.$t("Kwota"),
          dataIndex: "sum",
          width: "8%",
          scopedSlots: { customRender: "sum" },
        },
        {
          title: this.$t("Op."),
          dataIndex: "operation",
          width: "8",
          scopedSlots: { customRender: "operation" },
        },
      ],
      allSum: 0,
      form: this.$form.createForm(this, { name: "form_2" }),
      isSaveDisabled: false,
      domain: "",
      mpk_types_cord: {},
      common_sum: 0,
      checkChangedVal: false,
      common_balance: 0,
      common_vat: 0,
      kwotaHistoryVisible: false,
      kwotaVals: {},
      budgetSelecter: [],
      positionsSelect: {},
      budgetBalance: {},
      sumCheckTable: {},
      testObj: {},
      companyObj: {},
      timeTitle: "",
      timeTitleForCompany: "",
      myCompany: "",
      contractor: "",
      myCompanyTitle: "",
      contactorTitle: "",
      dealTitle: "",
      dealid: "",
      invoiceTypeSelect: {
        "Faktura Kosztowa": this.$t("Faktura Kosztowa"),
        Proforma: this.$t("Proforma"),
        "VAT Marza": this.$t("Faktura do Proformy"),
        Korygujaca: this.$t("Korygująca"),
        "Faktura zaliczkowa": this.$t("Faktura zaliczkowa"),
        "Faktura koncowa": this.$t("Faktura końcowa"),
      },
    };
  },
  computed: {
    resultPercent() {
      return parseFloat(
        100.0 -
          parseFloat(
            parseFloat(this.common_balance * 100) / parseFloat(this.allSum)
          ).toFixed(2)
      ).toFixed(2);
    },
    bankAccountList() {
      // let my_comp =
      //   this.form.getFieldValue("my_company") || this.document.my_company;
      // FIXME test2 (6) проверить
      let company = this.document.arrayCompany.find(
        (x) => x.ID == this.document.my_company
      );
      if (this.user_setup.BankAccount && company)
        return company[this.user_setup.BankAccount];
      return [];
    },
  },
  methods: {
    moment,
    getUser(id) {
      let user = this.document.userList.find((x) => x.ID == id);
      return user ? user.NAME + " " + user.LAST_NAME : "";
    },
    getCompanyAssign(id) {
      let company = this.document.arrayCompany.find((x) => x.ID == id);
      return company ? company.ASSIGNED_BY_NAME : "";
    },
    handleChangeOnlyDeal(tableKey, recordIndex) {
      // console.log(tableKey, "tableKey");
      // console.log(recordIndex, "tableKey");
      BX24.selectCRM(
        {
          entityType: ["deal"],
          multiple: false,
        },
        (info) => {
          let dealid = info.deal[0].id.split("_")[1];
          this.document.invoiceTable[tableKey]["sum_distribution"][
            recordIndex
          ].deal = dealid;
          // console.log(this.document, "this.document");
          this.findDeal(dealid);
          this.checkSaveBtnDisabled();
        }
      );
    },
    handleChangeMyCompany() {
      // eslint-disable-next-line
      BX24.selectCRM(
        {
          entityType: ["company"],
          multiple: false,
        },
        (info) => {
          this.myCompany = info.company[0].id.split("_")[1];
          this.myCompanyTitle = info.company[0].title;
          this.handlerChangeMainCompany(this.myCompany);
        }
      );
    },
    handleChangeContractor() {
      // eslint-disable-next-line
      BX24.selectCRM(
        {
          entityType: ["company"],
          multiple: false,
        },
        (info) => {
          this.contractor = info.company[0].id.split("_")[1];
          this.contactorTitle = info.company[0].title;
          this.handlerChangeContractor(this.contractor);
        }
      );
    },

    getCompany(id) {
      let company = this.document.arrayCompany.find((x) => x.ID == id);
      return company ? company.TITLE : "";
    },
    handlerChangeMainCompany(my_company) {
      let result = {};
      if (this.info.costCenter[my_company]) {
        result = this.info.costCenter[my_company].MPK_CostTypes.reduce(
          (accum, curr) => {
            for (let mpk of curr.MPK) {
              if (accum[mpk]) {
                accum[mpk].push(...curr.CostTypes);
              } else {
                accum[mpk] = curr.CostTypes;
              }
            }
            return accum;
          },
          {}
        );
      }
      this.mpk_types_cord = result;
      this.validationMpkFields(result);
    },
    validationMpkFields(mpk_types_cord) {
      let keys = Object.keys(mpk_types_cord);
      let values = Object.values(mpk_types_cord).flat();
      for (let subtable in this.document.invoiceTable) {
        for (let record in this.document.invoiceTable[subtable]
          .sum_distribution) {
          if (
            !keys.includes(
              this.document.invoiceTable[subtable].sum_distribution[record].mpk
            )
          ) {
            this.document.invoiceTable[subtable].sum_distribution[record].mpk =
              "";
          }
          if (
            !values.includes(
              this.document.invoiceTable[subtable].sum_distribution[record].type
            )
          ) {
            this.document.invoiceTable[subtable].sum_distribution[record].type =
              "";
          }
        }
      }
    },
    handlerKwotaDelete(index) {
      this.kwotaVals.history.splice(index, 1);
      this.updateKwota();
    },
    handlerChangePaymentDateReal(dateMoment, dateString) {
      if (this.kwotaVals.paidPercent < 100) {
        if (dateString) {
          this.validatePaymentDateReal = "success";
        } else {
          this.validatePaymentDateReal = "error";
        }
      }
    },
    handlerKwotaAdd() {
      let kwotaVal = +this.form.getFieldValue("kwotaVal");
      if (!kwotaVal) return;
      let payment = kwotaVal.toFixed(2);
      let date = this.form.getFieldValue("PaymentDateReal")
        ? moment(this.form.getFieldValue("PaymentDateReal")).format(
            "YYYY-MM-DD"
          )
        : 0;
      if (date && payment) {
        this.kwotaVals.history.push({
          date,
          payment,
          user: this.profile.ID,
        });
        this.form.setFieldsValue({
          PaymentDateReal: "",
          kwotaVal: "",
        });
        this.validatePaymentDateReal = "default";
        this.kwotaHistoryVisible = true;
        this.updateKwota();
      } else if (!date) {
        this.validatePaymentDateReal = "error";
      }
    },
    updateKwota() {
      this.kwotaVals.sum = +this.document.Quota.Netto;
      this.kwotaVals.paidSum = +this.kwotaVals.history
        .reduce((accum, curr) => accum + +curr.payment, 0)
        .toFixed(2);
      this.kwotaVals.paidPercent = +(
        (this.kwotaVals.paidSum * 100.0) /
        this.kwotaVals.sum
      ).toFixed(2);
      this.kwotaVals.leftToPay = +(
        this.kwotaVals.sum - this.kwotaVals.paidSum
      ).toFixed(2);
      this.kwotaVals.leftToPayPercent = +(
        100.0 - this.kwotaVals.paidPercent
      ).toFixed(2);
    },
    handleCurrencyCodeChange(e) {
      var curr = this.info.currency.find((x) => x.CURRENCY == e);
      if (!this.currencyDate || curr.CURRENCY == "PLN") {
        this.form.setFieldsValue({
          currencyVal: curr.AMOUNT,
        });
      } else {
        this.form.setFieldsValue({
          currencyCode: curr.CURRENCY,
        });
        this.handleSaleDateChange();
      }
    },
    handleSaleDateChange(e) {
      let code = this.form.getFieldValue("currencyCode");
      let date = e ? e : this.form.getFieldValue("PaymentDateReal");
      if (date) {
        date = moment(date).subtract(1, "days");
        this.currencyDate =
          date.isoWeekday() > 5
            ? date.subtract(date.isoWeekday() - 5, "days").format("YYYY-MM-DD")
            : date.format("YYYY-MM-DD");

        if (code != "PLN") {
          getCurrency({ code, date: this.currencyDate }).done((data) => {
            let res = JSON.parse(data);

            if (res.currency) {
              this.form.setFieldsValue({
                currencyVal: res.currency.rates[0]["mid"],
              });
              this.$message.success(this.$t("Currency updated"));
            }
          });
        }
      }
    },
    handleAdd(tableKey) {
      let last_index =
        this.document.invoiceTable[tableKey].sum_distribution.length - 1;
      const newData = {
        key:
          +this.document.invoiceTable[tableKey].sum_distribution[last_index]
            .key + 1,
        mpk: "",
        type: "",
        deal: "",
        firma: "",
        budget: {
          idBudget: null,
          nameBudget: "",
          idPosition: null,
          namePosition: "",
        },
        balance_sum: 0,
        sum: 0,
        accept: {
          status: false,
          permission: false,
        },
      };
      this.document.invoiceTable[tableKey].sum_distribution.push(newData);
    },
    onInputSum(item_sum, record_index, event, flag) {
      let val = parseFloat(event.toString().replace(",", "."));

      this.document.invoiceTable[item_sum].sum_distribution[record_index].sum =
        isNaN(val) ? 0 : val;

      this.changeBudgetBalance(item_sum, record_index, {
        sum: this.document.invoiceTable[item_sum].sum_distribution[record_index]
          .sum,
      });

      let result = this.document.invoiceTable[item_sum].sum_distribution.reduce(
        (sum, current) => sum + (current.sum == "" ? 0 : +current.sum),
        0
      );

      this.document.invoiceTable[item_sum].balance_sum =
        Math.round(
          (+this.document.invoiceTable[item_sum].koszty - +result) * 100
        ) / 100;
      // +this.document.invoiceTable[item_sum].sum - +result;

      /* this.common_balance = +this.document.invoiceTable
        .reduce(
          (sum, current) =>
            sum + (current.balance_sum == "" ? 0 : +current.balance_sum),
          0
        )
        .toFixed(2);*/
      this.common_balance =
        Math.round(
          +this.document.invoiceTable.reduce(
            (sum, current) =>
              sum + (current.balance_sum == "" ? 0 : +current.balance_sum),
            0
          ) * 100
        ) / 100;
      if (flag) this.checkSaveBtnDisabled();
    },
    onDelete(tableKey, recordKey) {
      this.document.invoiceTable[tableKey].balance_sum +=
        +this.document.invoiceTable[tableKey].sum_distribution[recordKey].sum;
      this.common_balance +=
        +this.document.invoiceTable[tableKey].sum_distribution[recordKey].sum;

      this.document.invoiceTable[tableKey].sum_distribution.splice(
        recordKey,
        1
      );

      this.checkSaveBtnDisabled();
    },
    submit(updateStatus) {
      this.changeSpinning();
      this.form.validateFields((err, values) => {
        var updateStatistic = false;
        requestStep(this.saveValues(updateStatus, values))
          .done((data) => {
            var res = JSON.parse(data);
            if (this.document.status != res.status)
              updateStatistic = {
                prev: this.document.status,
                next: res.status,
              };
            this.document.status = res.status;
            this.$message.success(this.$t("Document registration completed!"));
          })
          .fail((e) => {
            console.error(e);
            this.$message.error(this.$t("Document registration error"));
          })
          .always(() => {
            this.changeSpinning();
            this.onback(updateStatus, updateStatistic);
          });
      });
    },
    checkChanged() {
      var kk = false;
      this.form.validateFields((err, values) => {
        for (let field of Object.entries(this.saveValues(false, values))) {
          if (
            typeof field[1] == "object" &&
            Object.keys(field[1]).includes("old")
          ) {
            kk = true;
            break;
          }
        }
      });
      return kk;
    },
    addBankAccount() {
      let val = this.form.getFieldValue("bankAccount");
      let comp = this.form.getFieldValue("kontragent");
      if (val && comp && this.user_setup.BankAccount) {
        let companyBankAccount =
          this.COMPANY_LIST[comp][this.user_setup.BankAccount];

        if (!companyBankAccount) {
          companyBankAccount = [val];
        } else if (!companyBankAccount.includes(val)) {
          companyBankAccount.push(val);
        }
        let kk = {};
        kk[this.user_setup.BankAccount] = companyBankAccount;

        BX24.callMethod(
          "crm.company.update",
          {
            id: comp,
            fields: kk,
          },
          function (result) {
            if (result.error()) console.error(result.error());
            else {
              console.info(result.data());
            }
          }
        );
      }
    },
    handlerChangeContractor(e) {
      if (this.user_setup.BankAccount && e) {
        let company = this.document.arrayCompany.find((x) => x.ID == e);
        this.bankAccountList = company[this.user_setup.BankAccount];
      } else {
        this.bankAccountList = [];
      }
    },
    saveValues(updateStatus, values) {
      var format_moment = (date) =>
        date ? moment(date).format("YYYY-MM-DD") : "";
      let data = {
        run: "saveStep3onStep4",
        updateStatus,
        ID: this.document.ID,
        mainid: this.document.mainid,
        url: this.document.DOWNLOAD_URL,
        sum_distribution: this.document.invoiceTable,
      };
      let update = this.profile.ADMIN
        ? {
            my_company: this.myCompany,
            kontragent: this.contractor,
            bankAccount: values.bankAccount,
            num_invoice: values.num_invoice,
            payment: {
              type: values.paymentType,
              date: format_moment(values.paymentDate),
            },
            key_words: values.key_words,
            Teczka: values.Teczka,
            date_send: format_moment(values.date_send),
            date_recept: format_moment(values.date_recept),
            paymentDate: format_moment(values.paymentDate),
            plannedDate: format_moment(values.plannedDate),
            reminderDate: format_moment(values.reminderDate),
            PaymentDateReal: format_moment(values.PaymentDateReal),
            kwota: this.kwotaVals,
          }
        : {
            PaymentDateReal: format_moment(values.PaymentDateReal),
            kwota: this.kwotaVals,
          };
      for (let key in update) {
        if (
          key in this.document &&
          JSON.stringify(update[key]) != JSON.stringify(this.document[key])
        ) {
          update[key] = {
            old: this.document[key],
            new: update[key],
          };
        } else {
          delete update[key];
        }
      }
      Object.assign(data, update);

      return data;
    },
    changeSpinning() {
      this.$emit("changeSpinning");
    },
    onback(updateStatus, updateStatistic) {
      this.$emit("onback", {
        visible_doc: true,
        unshift_elem: true,
        remove_elem: this.document.ID,
        updateStatistic,
        updateStatus,
      });
    },
    changeBudget(event, item_key, record_key) {
      this.document.invoiceTable[item_key].sum_distribution[record_key].budget =
        event;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    async findDeal(dealId) {
      BX24.callMethod("crm.deal.get", { id: dealId }, (result) => {
        if (result.error()) {
          console.error(result.error());
        } else {
          let title = result.data().TITLE;
          this.testObj[result.data().ID] = title;
          this.testObj = { ...this.testObj };
        }
      });

      return "";
    },
    handleChangeDeal(tableKey, recordIndex) {
      BX24.selectCRM(
        {
          entityType: ["deal"],
          multiple: false,
        },
        (info) => {
          let dealId = parseInt(info.deal[0].id.replace(/[^\d]/g, ""));
          this.document.invoiceTable[tableKey]["sum_distribution"][
            recordIndex
          ].deal = dealId;

          if (dealId) {
            let deal = this.info.deal.find((x) => x.ID == dealId);

            if (deal) {
              if (deal.CURRENCY_ID == this.document.currency.code) {
                if (
                  !(
                    !this.document.invoiceTable[tableKey]["sum_distribution"][
                      recordIndex
                    ]["firma"] ||
                    deal["COMPANY_ID"] ==
                      this.document.invoiceTable[tableKey]["sum_distribution"][
                        recordIndex
                      ]["firma"]
                  )
                ) {
                  this.$message.info(this.$t("Zmień firmę!"));
                }
                this.document.invoiceTable[tableKey]["sum_distribution"][
                  recordIndex
                ]["firma"] = deal ? deal["COMPANY_ID"] : "";
                let budgetActive = this.budgetSelecter.find(
                  (el) => el.deal == dealId
                );
                if (budgetActive) {
                  if (
                    this.document.invoiceTable[tableKey]["sum_distribution"][
                      recordIndex
                    ]["budget"] == ""
                  ) {
                    this.document.invoiceTable[tableKey]["sum_distribution"][
                      recordIndex
                    ]["budget"] = {};
                  }
                  this.document.invoiceTable[tableKey]["sum_distribution"][
                    recordIndex
                  ]["budget"].idBudget = budgetActive ? budgetActive["id"] : "";
                  this.document.invoiceTable[tableKey]["sum_distribution"][
                    recordIndex
                  ]["budget"].nameBudget = budgetActive
                    ? budgetActive["nameBudget"]
                    : "";
                  this.document.invoiceTable[tableKey]["sum_distribution"][
                    recordIndex
                  ]["budget"].idPosition = "";
                  this.changeBudgetSelect(
                    budgetActive.id,
                    recordIndex,
                    tableKey
                  );
                } else {
                  this.document.invoiceTable[tableKey]["sum_distribution"][
                    recordIndex
                  ]["budget"].idBudget = null;
                  this.document.invoiceTable[tableKey]["sum_distribution"][
                    recordIndex
                  ]["budget"].nameBudget = "";
                  this.document.invoiceTable[tableKey]["sum_distribution"][
                    recordIndex
                  ]["budget"].idPosition = null;
                  this.document.invoiceTable[tableKey]["sum_distribution"][
                    recordIndex
                  ].sum = 0;
                  this.changeBudgetBalance(tableKey, recordIndex);
                  this.positionsSelect[recordIndex] = null;
                  this.onInputSum(tableKey, recordIndex, 0, true);
                  this.document.invoiceTable[tableKey]["sum_distribution"] = [
                    ...this.document.invoiceTable[tableKey]["sum_distribution"],
                  ];
                  this.changeBudgetSelect(null, recordIndex, tableKey);
                }
              } else {
                this.$message.info(this.$t("waluta się nie zgadza!"));
              }
            }
          } else {
            this.handleChangeDealCleaner(tableKey, recordIndex);
          }
          let target = {
            ...this.document.invoiceTable[tableKey]["sum_distribution"][
              recordIndex
            ],
          };
          this.document.invoiceTable[tableKey]["sum_distribution"][
            recordIndex
          ] = target;

          this.checkSaveBtnDisabled();
        }
      );
    },
    handleChangeDealCleaner: (tableKey, recordIndex) => {
      this.document.invoiceTable[tableKey]["sum_distribution"][recordIndex][
        "firma"
      ] = "";
      this.document.invoiceTable[tableKey]["sum_distribution"][recordIndex][
        "budget"
      ].idBudget = null;
      this.document.invoiceTable[tableKey]["sum_distribution"][recordIndex][
        "budget"
      ].nameBudget = "";
      this.document.invoiceTable[tableKey]["sum_distribution"][recordIndex][
        "budget"
      ].idPosition = null;
      this.document.invoiceTable[tableKey]["sum_distribution"][
        recordIndex
      ].sum = 0;
      this.changeBudgetBalance(tableKey, recordIndex);
      this.positionsSelect[recordIndex] = null;
      this.onInputSum(tableKey, recordIndex, 0, true);
      this.document.invoiceTable[tableKey]["sum_distribution"] = [
        ...this.document.invoiceTable[tableKey]["sum_distribution"],
      ];
      this.changeBudgetSelect(null, recordIndex, tableKey);
    },
    showPreview() {
      this.$emit("showPreview", false);
    },
    findCompany(companyID) {
      // if (companyID) {
      //   BX24.callMethod("crm.company.get", { id: companyID }, (result) => {
      //     if (result.error()) {
      //       console.error(result.error());
      //     } else {
      //       this.timeTitleForCompany = result.data().TITLE;
      //     }
      //   });
      // }
      // return this.timeTitleForCompany;

      BX24.callMethod("crm.company.get", { id: companyID }, (result) => {
        if (result.error()) {
          console.error(result.error());
        } else {
          let title = result.data().TITLE;
          this.companyObj[result.data().ID] = title;
          this.companyObj = { ...this.companyObj };
        }
      });

      return "";
    },
    handleChangeFirma(tableKey, recordIndex) {
      /*if (compId) {
        let deal = this.document.alldeal.find((x) => x.COMPANY_ID == compId);
        this.document.invoiceTable[tableKey]["sum_distribution"][recordIndex][
          "deal"
        ] = deal ? deal["ID"] : "";
      } else {
        this.document.invoiceTable[tableKey]["sum_distribution"][recordIndex][
          "deal"
        ] = "";
      }*/
      // BX24.selectCRM(
      //   {
      //     entityType: ["company"],
      //     multiple: false,
      //   },
      //   (info) => {
      //     let companyID = info.company[0].id.split("_")[1];
      //     this.document.invoiceTable[tableKey]["sum_distribution"][
      //           recordIndex
      //         ].firma = companyID;
      //   }
      // );
      // this.checkSaveBtnDisabled();

      BX24.selectCRM(
        {
          entityType: ["company"],
          multiple: false,
        },
        (info) => {
          let companyID = info.company[0].id.split("_")[1];
          this.document.invoiceTable[tableKey]["sum_distribution"][
            recordIndex
          ].firma = companyID;

          this.findCompany(companyID);
          this.checkSaveBtnDisabled();
        }
      );
    },
    // TODO param table, record and 0 val
    checkSaveBtnDisabled(invoiceChanged = true) {
      let kk = this.document.invoiceTable.findIndex((x) => x.balance_sum != 0);
      this.isSaveDisabled = kk == -1;
      for (let table of this.document.invoiceTable) {
        for (let field of table.sum_distribution) {
          if (!field.mpk || !field.type || !field.deal) {
            this.$emit("handlerSaveDisabled", {
              isSaveDisabled: true,
              invoiceChanged,
            });
            return;
          }
        }
      }
      this.$emit("handlerSaveDisabled", {
        isSaveDisabled: !this.isSaveDisabled,
        invoiceChanged,
      });
    },

    downloadBudget() {
      let budget;
      getBudget()
        .done((data) => {
          this.$message.info(this.$t("Download complete!"));
          let item = data == "" ? {} : JSON.parse(data);
          if (Array.isArray(item)) {
            budget = item;
            let resultBudget = budget.map((el, key) => {
              return {
                key,
                id: el.ID,
                nameBudget: el.PROPERTY_VALUES.nameBudget,
                deal: el.PROPERTY_VALUES.deal,
                positions: 0,
              };
            });
            this.budgetSelecter = resultBudget;

            for (let i in this.document.invoiceTable) {
              if (this.document.invoiceTable[i].sum_distribution) {
                for (let iSum in this.document.invoiceTable[i]
                  .sum_distribution) {
                  let dealId =
                    this.document.invoiceTable[i].sum_distribution[iSum]?.deal;

                  if (dealId) {
                    let budgetActiveId = undefined;
                    if (
                      this.document.invoiceTable[i].sum_distribution[iSum]
                        ?.budget?.idBudget
                    ) {
                      budgetActiveId =
                        this.document.invoiceTable[i].sum_distribution[iSum]
                          ?.budget?.idBudget;
                    } else {
                      let budgetActive = this.budgetSelecter.find(
                        (el) => el.deal == dealId
                      );
                      budgetActiveId = budgetActive
                        ? budgetActive.id
                        : undefined;
                    }
                    if (budgetActiveId) {
                      this.changeBudgetSelect(budgetActiveId, iSum, i);
                    }
                  }
                }
              }
            }
          }
        })
        .fail((e) => {
          console.err(e);
          this.$message.error(this.$t("Error loading document"));
        });
    },
    changeBudgetSelect(id, index, tableKey) {
      getPosition(id)
        .done((data) => {
          let item = data == "" ? {} : JSON.parse(data);
          if (item.length > 0) {
            this.positionsSelect[index] = item.map((el, key) => {
              return {
                key,
                id: el.ID,
                amountConnected: el.PROPERTY_VALUES.amountConnected,
                amountNet: el.PROPERTY_VALUES.amountNet,
                costCenter: el.PROPERTY_VALUES.costCenter,
                costType: el.PROPERTY_VALUES.costType,
                idBudget: el.PROPERTY_VALUES.idBudget,
                namePosition: el.PROPERTY_VALUES.namePosition,
              };
            });
          } else {
            this.positionsSelect[index] = null;
            this.changeBudgetBalance(tableKey, index);
          }
          this.positionsSelect = { ...this.positionsSelect };
          let subResult = null;
          if (
            this.document.invoiceTable[tableKey].sum_distribution[index].budget
              .idPosition
          ) {
            let position = this.positionsSelect[index].find(
              (el) =>
                el.id ==
                this.document.invoiceTable[tableKey].sum_distribution[index]
                  .budget.idPosition
            );
            if (position) {
              subResult = position.amountNet - position.amountConnected;
              this.document.invoiceTable[tableKey].sum_distribution[index].mpk =
                position.costType;
              this.document.invoiceTable[tableKey].sum_distribution[
                index
              ].type = position.costCenter;
            } else {
              this.document.invoiceTable[tableKey].sum_distribution[index].mpk =
                null;
              this.document.invoiceTable[tableKey].sum_distribution[
                index
              ].type = null;
            }
            this.changeBudgetBalance(tableKey, index, {
              balance: subResult,
              idPosition: position.id,
            });
          }
        })
        .fail((e) => {
          console.err(e);
          this.$message.error(this.$t("Error loading document"));
        });
    },
    handleChangeBudgetPosition(idPosition, tableKey, recordIndex, text) {
      if (idPosition) {
        this.document.invoiceTable[tableKey].sum_distribution[
          recordIndex
        ].budget = text;
        let subResult = undefined;
        if (idPosition) {
          let position = this.positionsSelect[recordIndex].find(
            (el) => el.id == idPosition
          );
          this.document.invoiceTable[tableKey].sum_distribution[
            recordIndex
          ].budget.namePosition = position.namePosition;
          if (position) {
            subResult = position.amountNet - position.amountConnected;

            this.document.invoiceTable[tableKey].sum_distribution[
              recordIndex
            ].mpk = position.costType;
            this.document.invoiceTable[tableKey].sum_distribution[
              recordIndex
            ].type = position.costCenter;
          }
          this.changeBudgetBalance(tableKey, recordIndex, {
            balance: subResult,
            idPosition: position.id,
          });
        }
      } else {
        this.changeBudgetBalance(tableKey, recordIndex);
        this.document.invoiceTable[tableKey].sum_distribution[recordIndex].mpk =
          null;
        this.document.invoiceTable[tableKey].sum_distribution[
          recordIndex
        ].type = null;
      }
      this.checkSaveBtnDisabled();
    },
    getNameBudget(id) {
      let budget = this.budgetSelecter.find((el) => el.id == id);
      return budget ? budget.nameBudget : "";
    },
    getSumBudget(budget, index) {
      let result;
      if (budget?.idPosition) {
        let position = this.positionsSelect[index].find(
          (el) => el.id == budget?.idPosition
        );
        if (position) {
          result = position.amountNet - position.amountConnected;
        }
      }
      return result;
    },
    checkSumBudget(idBudget, idPosition, sum, index) {
      getPosition(idBudget)
        .done((data) => {
          let item = data == "" ? {} : JSON.parse(data);
          let position = item.find(
            (el) => el.ID == idPosition
          )?.PROPERTY_VALUES;
          if (position) {
            this.sumCheckTable[index] =
              position.amountNet - sum >= 0 ? " " : "!";
            this.sumCheckTable = { ...this.sumCheckTable };
          }
        })
        .fail((e) => {
          console.err(e);
          this.$message.error(this.$t("Error loading document"));
        });
    },
    calcBalanceBudget(tableIndex, index) {
      let result;
      if (this.budgetBalance[tableIndex]) {
        if (this.budgetBalance[tableIndex][index]) {
          let budget = this.budgetBalance[tableIndex][index];
          if (budget.balance) {
            let sum = 0;
            if (budget.idPosition) {
              for (let i in this.budgetBalance) {
                for (let j in this.budgetBalance[i]) {
                  if (
                    budget.idPosition == this.budgetBalance[i][j].idPosition
                  ) {
                    if (this.budgetBalance[i][j].sum) {
                      sum += this.budgetBalance[i][j].sum;
                    }
                  }
                }
              }
            }
            result = budget.balance - sum;
          } else {
            result = "";
          }
        } else {
          result = "";
        }
      } else {
        result = "";
      }
      return result;
    },
    changeBudgetBalance(tableIndex, index, value) {
      if (value) {
        if (!this.budgetBalance[tableIndex]) {
          this.budgetBalance[tableIndex] = {};
        }
        if (!this.budgetBalance[tableIndex][index]) {
          let budget = {};
          this.budgetBalance[tableIndex][index] = budget;
        }
        for (let key in value) {
          this.budgetBalance[tableIndex][index][key] = value[key];
        }
      } else {
        this.budgetBalance[tableIndex][index] = null;
      }
      this.budgetBalance[tableIndex][index] = {
        ...this.budgetBalance[tableIndex][index],
      };
      this.budgetBalance[tableIndex] = { ...this.budgetBalance[tableIndex] };
    },
  },
  mounted() {
    this.contractor = this.document.kontragent;
    this.contactorTitle = this.getCompany(this.document.kontragent);
    this.myCompany = this.document.my_company;
    this.myCompanyTitle = this.getCompany(this.document.my_company);
    let auth = BX24.getAuth();
    this.domain = auth.domain;
    this.downloadBudget();
    this.handlerChangeContractor(this.document.kontragent);
    this.payDATE = this.document.PaymentDateReal ? true : false;
    if (this.current == 1) {
      if (!this.document.kwota || !this.document.kwota.history)
        this.document.kwota = {
          leftToPayPercent: 0,
          leftToPay: 0,
          paidPercent: 0,
          paidSum: 0,
          sum: 0,
          history: [],
        };
      this.kwotaVals = Object.assign({}, this.kwotaVals, this.document.kwota);
      this.updateKwota();
      if (this.document.my_company)
        this.handlerChangeMainCompany(this.document.my_company);
      let index = this.columns.findIndex((x) => x.dataIndex == "deal");
      delete this.columns[index].customRender;
      this.columns[index]["scopedSlots"] = { customRender: "deal" };

      let indexFirma = this.columns.findIndex((x) => x.dataIndex == "firma");
      delete this.columns[indexFirma].customRender;
      this.columns[indexFirma]["scopedSlots"] = { customRender: "firma" };
    }
    if (this.current == 2 || this.current == 4 || this.current == 5) {
      this.columns[5].title = this.$t("Zaakceptowane");
    } else {
      this.columns[5].title = this.$t("Op.");
    }
    if (Array.isArray(this.document.invoiceTable)) {
      for (let item of this.document.invoiceTable) {
        this.common_vat += +item.vat2;
        this.common_sum += +item.koszty;
        // this.common_balance += +item.sum;
      }
    } else {
      this.document.invoiceTable = [];
    }
    this.common_vat = this.common_vat.toFixed(2);
    // this.common_sum = this.common_sum.toFixed(2);
    // this.common_balance = this.common_balance.toFixed(2);
    this.allSum = this.common_sum = this.common_sum.toFixed(2);

    for (let i in this.document.invoiceTable) {
      if (this.document.invoiceTable[i].sum_distribution) {
        let result = this.document.invoiceTable[i].sum_distribution.reduce(
          (sum, current) => sum + (current.sum ? +current.sum : 0),
          0
        );

        this.document.invoiceTable[i].balance_sum =
          +this.document.invoiceTable[i].koszty - +result;
      } else {
        this.document.invoiceTable[i]["sum_distribution"] = [
          {
            key: 0,
            mpk: "",
            type: "",
            deal: "",
            firma: "",
            budget: {
              idBudget: null,
              idPosition: null,
            },
            balance_sum: 0,
            sum: 0,
            accept: {
              status: false,
              permission: false,
            },
          },
        ];
        this.onInputSum(i, 0, 0, false);
      }
    }

    if (this.current == 2) {
      for (let i in this.document.invoiceTable) {
        for (let j in this.document.invoiceTable[i].sum_distribution) {
          let item = this.document.invoiceTable[i].sum_distribution[j];
          if (this.document.my_company in this.document.right) {
            if (this.document.right[this.document.my_company]["ACCESS"]) {
              let filter = this.document.right[this.document.my_company][
                "ACCESS"
              ]
                .filter((x) => x.MPK.includes(item.mpk))
                .flatMap((x) => x.verifications);

              filter = filter
                .concat(
                  this.document.right[this.document.my_company]["HUBLIDER"],
                  this.defaultResponsible.verification,
                  this.defaultResponsible.processing
                )
                .filter(Boolean);
              item["accept"]["accept_users"] = [...new Set(filter)];
            } else {
              item["accept"]["accept_users"] = [];
            }
          }
          if (this.profile.ADMIN) {
            item["accept"]["permission"] = true;
          } else {
            item["accept"]["permission"] = item["accept"][
              "accept_users"
            ].includes(this.profile.ID);
          }

          item["accept"]["status"] = item["accept"]["status"] == "true";
          item["accept"]["user"] = "";
          if (item["accept"]["permission"]) {
            this.$emit("handlerSaveDisabled", {
              isSaveDisabled: false,
              invoiceChanged: false,
            });
          }
        }
      }
    } else if (this.current == 1) {
      this.checkSaveBtnDisabled(false);
    }

    this.common_balance = +this.document.invoiceTable
      .reduce(
        (sum, current) =>
          sum + (current.balance_sum == "" ? 0 : +current.balance_sum),
        0
      )
      .toFixed(2);

    if (this.document.costInfo.MPK_CostTypes) {
      this.mpkForTypes = this.document.costInfo.MPK_CostTypes.map(
        (item) => item.MPK
      ).flat();
      this.costTypesForMpk = this.document.costInfo.MPK_CostTypes.map(
        (item) => item.CostTypes
      ).flat();
    }

    BX24.fitWindow();
  },
};
</script>
<style scoped>
</style>
